import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

// const BASE_URL = process.env.REACT_APP_API_ENDPOINT;

class Service {

    constructor() {
        let service = axios.create({
            // baseURL: BASE_URL,
            headers: {
                'Content-type': 'application/json; charset=utf-8',
                'X-Requested-With': 'XMLHttpRequest'
            },
            timeout: 60000,
            withCredentials: false
        });

        service.interceptors.request.use(
            async (config) => {
                if (config.url === 'https://passport-api.services.r2net.com/auth') {
                    config.withCredentials = true;
                }

                const userToken = this.getCookie('Ut');

                if (userToken) {
                    if (global.DMarket && global.DMarket.Config.Ut !== userToken) {
                        global.location.reload();
                        throw new axios.Cancel('Token mismatch');
                    }
                }

                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        this.service = service;

    }

    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    handleError(path, params, err) {
        if (err && axios.isCancel(err)) { // Catch axios request cancelation
            console.log('Cancel request token', err.message)
        }
        else {
            if (err && err.response && err.response.status === 401) { // Unauthorized
                //TODO: Check if it can be improved
                console.log('user unautorized');
            }
            else if (err && err.response && err.response.status === 404) { // Not Found
                console.log('Error 404');
            }
            else if (err && err.message && err.message.includes('timeout')) {
                console.log(err.message);
            }
            else {
                var errorParams = params ? JSON.stringify(params) : "";

                console.log(`Had Issues getting to the backend, endpoint: ${path}, with data: ${errorParams}`);
                console.dir(err);
            }

            throw err;
        }

    }

    async get(path, params, loaderTrackerArea, timeout) {
        try {
            const response = await trackPromise(this.service.request({
                method: 'GET',
                url: path,
                params,
                timeout: timeout
            }), loaderTrackerArea);

            return response.data;
        } catch (err) {
            this.handleError(path, params, err);
        }
    }

    async post(path, payload, loaderTrackerArea, headers) {
        try {
            const response = await trackPromise(this.service.request({
                method: 'POST',
                url: path,
                data: payload,
                headers: headers
            }), loaderTrackerArea);

            return response.data;
        } catch (err) {
            this.handleError(path, payload, err);
        }
    }

    async put(path, payload, loaderTrackerArea) {
        try {
            const response = await trackPromise(this.service.request({
                method: 'PUT',
                url: path,
                data: payload
            }), loaderTrackerArea);

            return response.data;
        } catch (err) {
            this.handleError(path, payload, err);
        }
    }

    async delete(path, payload, loaderTrackerArea) {
        try {
            const response = await trackPromise(this.service.request({
                method: 'DELETE',
                url: path,
                data: payload
            }), loaderTrackerArea);

            return response.data;
        } catch (err) {
            this.handleError(path, payload, err);
        }
    }

    async all(requests, loaderTrackerArea) {
        let requestArr = [];
        requests.forEach(request => {
            let currentRequest;
            const { url, params, method } = request;

            if (method === 'GET') {
                currentRequest = this.service.get(url, { params: params })
            } else {
                currentRequest = this.service.request({
                    method: method,
                    url: url,
                    data: params
                });
            }
            requestArr.push(currentRequest)
        });

        try {
            const values = await trackPromise(Promise.all(requestArr), loaderTrackerArea)

            return values;
        } catch (err) {
            console.log('Error: ', err)
            //this.handleError(path, payload, err);
        }
    }

    async uploadFile(path, file, loaderTrackerArea, additionalData = {}, timeout) {
        try {
            let formData = new FormData();
            formData.append('file', file);

            // Add any additional data to the formData
            for (let key in additionalData) {
                if (additionalData.hasOwnProperty(key)) {
                    formData.append(key, additionalData[key]);
                }
            }

            const response = await trackPromise(this.service.request({
                method: 'POST',
                url: path,
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                timeout: timeout !== undefined ? timeout : this.service.defaults.timeout
            }), loaderTrackerArea);

            return response.data;
        } catch (err) {
            this.handleError(path, null, err);
        }
    }
}

//export default Service;
export default new Service();